import { createAPI } from '@common'

export default {
  // 问卷列表接口
  postPollQuestionList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0mjtu', 'post', config),

  // sso登录
  postPollLoginForm: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0mphjoGpsn', 'post', config),

  // 后台登录
  postPollLogin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0mphjo', 'post', config),

  // sso登录
  postPollQuestionCreate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0dsfbuf', 'post', config),

  // 问卷网sso登录
  postPollWjwLoginForm: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0xkx0mphjoTtp', 'post', config),
  // 问卷网列表接口
  postPollWjwLogin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0xkx0mjtu', 'post', config),
  //  快速创建空白问卷
  postPollWjwCreate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0xkx0dsfbuf', 'post', config),
  //  获取问卷相关url
  postPollWjwGetUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0qpmm0xkx0hfuVsm', 'post', config),
}
